import { useAudioTranscription } from "@/hooks/transcriber/useAudioTranscription";
import { useAudioTranscriptionDisabled } from "@/hooks/transcriber/useAudioTranscriptionDisabled";

export interface IUseAudioTranscription {
  setStream: (stream: MediaStream) => void;
  audioStream: MediaStream | null;
  transcription: string;
  finished: boolean;
  reset: () => void;
  finishSession: () => void;
  pauseStream: () => void;
  isProviderReady: boolean;
}

export const getAudioTranscriptionHook = (
  type: boolean
): (() => IUseAudioTranscription) => {
  switch (type) {
    case true:
      return useAudioTranscription;
    case false:
    default:
      return useAudioTranscriptionDisabled;
  }
};
